<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
    <path
      d="M12.5 15.25C12.5 14.0074 10.8211 13 8.75 13C6.67893 13 5 14.0074 5 15.25M15.5 13.0003C15.5 12.0776 14.5744 11.2847 13.25 10.9375M2 13.0003C2 12.0776 2.92557 11.2847 4.25 10.9375M13.25 7.92708C13.7103 7.51509 14 6.91637 14 6.25C14 5.00736 12.9926 4 11.75 4C11.1737 4 10.6481 4.21664 10.25 4.57292M4.25 7.92708C3.78969 7.51509 3.5 6.91637 3.5 6.25C3.5 5.00736 4.50736 4 5.75 4C6.32627 4 6.85193 4.21664 7.25 4.57292M8.75 10.75C7.50736 10.75 6.5 9.74264 6.5 8.5C6.5 7.25736 7.50736 6.25 8.75 6.25C9.99264 6.25 11 7.25736 11 8.5C11 9.74264 9.99264 10.75 8.75 10.75Z"
      stroke="#252525"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
<script setup lang="ts"></script>
<style lang=""></style>
